/**
 * Service helpers for Control Efficacy tab
 */

// Allowed ranges
export const CONTROL_EFFICACY_MIN_VALUE = 1;
export const CONTROL_EFFICACY_MAX_VALUE = 10;

export const DESIGN_SCORE_OPTIONS = Array.from(
    { length: CONTROL_EFFICACY_MAX_VALUE },
    (_, index) => index + 1
);
export const IMPLEMENTATION_SCORE_OPTIONS = [...DESIGN_SCORE_OPTIONS];

// Matrix describing the Control Efficacy value for every Implementation/Design combination
const CONTROL_EFFICACY_MATRIX = {
    1: [1, 1, 1, 2, 2, 2, 3, 3, 3, 3],
    2: [1, 1, 2, 3, 3, 3, 4, 4, 4, 5],
    3: [1, 2, 3, 3, 4, 4, 5, 5, 5, 6],
    4: [2, 3, 3, 4, 5, 5, 5, 6, 6, 7],
    5: [2, 3, 4, 5, 5, 6, 6, 7, 7, 7],
    6: [2, 3, 4, 5, 6, 6, 7, 7, 8, 8],
    7: [3, 4, 5, 5, 6, 7, 7, 8, 8, 9],
    8: [3, 4, 5, 6, 7, 7, 8, 8, 9, 9],
    9: [3, 4, 5, 6, 7, 7, 8, 9, 9, 10],
    10: [3, 5, 6, 7, 7, 8, 9, 9, 10, 10],
};

/**
 * Calculate Control Efficacy from design and implementation scores.
 */
export const calculateControlEfficacy = (design, implementation) => {
    const designScore = parseInt(design, 10);
    const implementationScore = parseInt(implementation, 10);

    if (
        Number.isNaN(designScore) ||
        Number.isNaN(implementationScore) ||
        designScore < CONTROL_EFFICACY_MIN_VALUE ||
        designScore > CONTROL_EFFICACY_MAX_VALUE ||
        implementationScore < CONTROL_EFFICACY_MIN_VALUE ||
        implementationScore > CONTROL_EFFICACY_MAX_VALUE
    ) {
        return null;
    }

    const implementationRow = CONTROL_EFFICACY_MATRIX[implementationScore];
    if (!implementationRow) return null;

    const efficacy = implementationRow[designScore - 1];
    return typeof efficacy === "number" ? efficacy : null;
};

/**
 * Get a color (HEX string) for the calculated control efficacy score
 */
export const getControlEfficacyColor = (score) => {
    if (!score) return "bg-[#0000FF]";
    const numeric = parseInt(score, 10);
    if (Number.isNaN(numeric)) return "bg-[#0000FF]";

    if (numeric >= 9) return "bg-[#0000FF]";
    if (numeric >= 7) return "bg-[#008000]";
    if (numeric >= 5) return "bg-[#FEF800]";
    if (numeric >= 3) return "bg-[#F66400]";
    return "bg-[#DA0000]";
};

